


























import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import Season = Orders.Season;

@Component({
  name: 'SeasonComponent',
})
export default class SeasonComponent extends Vue {
  @Prop({ required: true, type: Object })
  season!: Season;
}
